function validateImageUpload(file, fileInput, errorBox) {
  if (errorBox) errorBox.classList.add('hidden');

  const allowedTypes = ['image/jpeg', 'image/png', 'image/gif'];
  if (!allowedTypes.includes(file.type)) {
    if (errorBox) {
      errorBox.textContent = 'アップロードできる画像の拡張子は.jpg、.png、.gif形式です。';
      errorBox.classList.remove('hidden');
    }
    return false;
  }

  if (fileInput && fileInput.files !== file) {
    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(file);
    fileInput.files = dataTransfer.files;
    const event = new Event('change', { bubbles: true });
    fileInput.dispatchEvent(event);
  }

  return true;
}

// 画像フォームのリセット
function resetImageForm() {
  const imageForm = document.querySelector('.js-chat_widget__form-image');
  if (imageForm) {
    imageForm.reset();
    const imagePreview = document.querySelector('.js-image-preview');
    if (imagePreview) imagePreview.remove();
    const existingThumbnails = imageForm.querySelectorAll('.js-p-chat-widget-image-thumbnail');
    existingThumbnails.forEach(thumbnail => thumbnail.remove());
    const textForm = document.querySelector('.js-chat_widget__form-text');
    if (textForm) textForm.classList.remove('hidden');
    if (imageForm) imageForm.classList.add('hidden');
    const sendButtonImage = imageForm.querySelector('.js-send-button-image');
    if (sendButtonImage) {
      sendButtonImage.classList.add('hidden');
      sendButtonImage.disabled = false;
    }
    const helpTextDefault = document.querySelector('.js-help-text-default');
    const helpTextInput = document.querySelector('.js-help-text-input');
    const helpTextImage = document.querySelector('.js-help-text-image');
    if (helpTextDefault) helpTextDefault.classList.remove('hidden');
    if (helpTextInput) helpTextInput.classList.add('hidden');
    if (helpTextImage) helpTextImage.classList.add('hidden');
    const errorBox = document.querySelector('.js-chat_widget__form-error');
    if (errorBox) errorBox.classList.add('hidden');
  }
}

// テキスト/画像フォームの切り替え
function switchToImageForm(textForm, imageForm, sendButtonImage, helpTextDefault, helpTextInput, helpTextImage) {
  textForm.classList.add('hidden');
  imageForm.classList.remove('hidden');
  sendButtonImage.classList.remove('hidden');
  sendButtonImage.disabled = false;
  helpTextDefault.classList.add('hidden');
  helpTextInput.classList.add('hidden');
  helpTextImage.classList.remove('hidden');
}

function switchToTextForm(textForm, imageForm, sendButtonImage, helpTextDefault, helpTextInput, helpTextImage) {
  const existingThumbnails = document.querySelectorAll('.js-p-chat-widget-image-thumbnail');
  existingThumbnails.forEach(thumbnail => thumbnail.remove());
  textForm.classList.remove('hidden');
  imageForm.classList.add('hidden');
  sendButtonImage.classList.add('hidden');
  sendButtonImage.disabled = true;
  helpTextDefault.classList.remove('hidden');
  helpTextInput.classList.add('hidden');
  helpTextImage.classList.add('hidden');
}

// プレビュー表示
function showImagePreview(file, imageForm, fileInput, textForm, sendButtonImage, helpTextDefault, helpTextInput, helpTextImage) {
  const existingThumbnails = document.querySelectorAll('.js-p-chat-widget-image-thumbnail');
  existingThumbnails.forEach(thumbnail => thumbnail.remove());
  const template = document.getElementById('js-chat-image-thumbnail');
  if (!template) return;
  const thumbnailContainer = template.content.firstElementChild.cloneNode(true);
  const img = thumbnailContainer.querySelector('img');
  const deleteButton = thumbnailContainer.querySelector('.js-p-chat-widget-image-delete');
  const reader = new FileReader();
  reader.onload = function(event) {
    const imageUrl = event.target.result;
    img.src = imageUrl;
    img.alt = 'プレビュー画像';
    switchToImageForm(textForm, imageForm, sendButtonImage, helpTextDefault, helpTextInput, helpTextImage);
    imageForm.insertBefore(thumbnailContainer, fileInput);
  };
  reader.readAsDataURL(file);
  deleteButton.addEventListener('click', function(e) {
    e.preventDefault();
    thumbnailContainer.remove();
    fileInput.value = '';
    switchToTextForm(textForm, imageForm, sendButtonImage, helpTextDefault, helpTextInput, helpTextImage);
  });
}

// 画像送信フォームの初期化
function initPublicImageForm() {
  const imageForm = document.querySelector('.js-chat_widget__form-image');
  if (imageForm) {
    imageForm.addEventListener('submit', function(event) {
      const sendButtonImage = imageForm.querySelector('.js-send-button-image');
      if (sendButtonImage) {
        sendButtonImage.disabled = true;
      }
      setTimeout(function() {
        resetImageForm();
      }, 100);
    });
  }
}

// 画像アップローダー初期化（クリップボタン・ドラッグ&ドロップ対応）
function initChatImageUploader() {
  const textForm = document.querySelector('.js-chat_widget__form-text');
  const imageForm = document.querySelector('.js-chat_widget__form-image');
  const textarea = textForm?.querySelector('.js-chat-textarea');
  const clipButton = textForm?.querySelector('.js-clip-button');
  const sendButton = textForm?.querySelector('.js-send-button');
  const sendButtonImage = imageForm?.querySelector('.js-send-button-image');
  const helpTextDefault = document.querySelector('.js-help-text-default');
  const helpTextInput = document.querySelector('.js-help-text-input');
  const helpTextImage = document.querySelector('.js-help-text-image');
  const fileInput = imageForm?.querySelector('.js-image-upload');
  const errorBox = document.querySelector('.js-chat_widget__form-error');
  const chatBody = document.querySelector('.js-chat_widget__body');

  if (!textForm || !imageForm || !textarea || !clipButton || !sendButton || !fileInput) return;

  clipButton.addEventListener('click', function(e) {
    e.preventDefault();
    fileInput.click();
  });

  fileInput.addEventListener('change', function(e) {
    const file = e.target.files[0];
    if (!file) return;
    if (!validateImageUpload(file, null, errorBox)) {
      fileInput.value = '';
      return false;
    }
    showImagePreview(file, imageForm, fileInput, textForm, sendButtonImage, helpTextDefault, helpTextInput, helpTextImage);
  });

  textarea.addEventListener('drop', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const dt = e.dataTransfer;
    const files = dt.files;
    if (files.length > 0) {
      const file = files[0];
      if (!validateImageUpload(file, fileInput, errorBox)) {
        return;
      }
    }
  });

  if (chatBody) {
    chatBody.addEventListener('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
    });
    chatBody.addEventListener('dragleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
    });
    chatBody.addEventListener('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      const dt = e.dataTransfer;
      const files = dt.files;
      if (files.length > 0) {
        const file = files[0];
        if (!validateImageUpload(file, null, errorBox)) {
          return;
        }
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        fileInput.files = dataTransfer.files;
        const event = new Event('change', { bubbles: true });
        fileInput.dispatchEvent(event);
      }
    });
  }

  // 画像送信（送信UI）初期化
  if (typeof initPublicImageForm === 'function') initPublicImageForm();
}

// 画像モーダル
function showImageModal(src) {
  let modal = document.querySelector('.js-p-chat-widget-image-modal');
  if (modal) modal.remove();
  const template = document.getElementById('js-chat-image-modal');
  if (!template) return;
  modal = template.content.firstElementChild.cloneNode(true);
  const img = modal.querySelector('img');
  img.src = src;
  modal.addEventListener('click', function() { modal.remove(); });
  img.addEventListener('click', function(e) { e.stopPropagation(); });
  document.body.appendChild(modal);
}

function initImageModal() {
  $(document).on('click', '.js-chat-image', function() {
    const src = $(this).attr('src');
    showImageModal(src);
  });
  $(document).on('click', '.js-p-chat-widget-image-thumbnail img', function(e) {
    e.preventDefault();
    const src = $(this).attr('src');
    showImageModal(src);
  });
}

window.initPublicImageForm = initPublicImageForm;
window.initChatImageUploader = initChatImageUploader;
window.initImageModal = initImageModal;